import './spokane/style';
import FormStructure from './spokane/form_structure';

export default FormStructure;